/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Detaileddescriptionofyourbusiness4Inputs */

const en_detaileddescriptionofyourbusiness4 = /** @type {(inputs: Detaileddescriptionofyourbusiness4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed description of your business`)
};

const de_detaileddescriptionofyourbusiness4 = /** @type {(inputs: Detaileddescriptionofyourbusiness4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausführliche Beschreibung deines Unternehmens`)
};

/**
* | output |
* | --- |
* | "Detailed description of your business" |
*
* @param {Detaileddescriptionofyourbusiness4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const detaileddescriptionofyourbusiness4 = /** @type {((inputs?: Detaileddescriptionofyourbusiness4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Detaileddescriptionofyourbusiness4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_detaileddescriptionofyourbusiness4(inputs)
	return de_detaileddescriptionofyourbusiness4(inputs)
});
export { detaileddescriptionofyourbusiness4 as "detailedDescriptionOfYourBusiness" }